import { InterpolationOptions } from "i18next";

/**
 *
 * Format docs for date
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 *
 */
export const formatDate = (
  value: number,
  format: string,
  lng: string | undefined
): string | number => {
  const options = toOptions(format, "date");
  return options === null || Object.getOwnPropertyNames(options).length === 0
    ? value
    : new Intl.DateTimeFormat(lng, options).format(new Date(value));
};

/**
 *
 * Format docs for number / currency
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
 *
 */
export const formatNumber = (
  value: number,
  format: string,
  lng: string | undefined
): string | number => {
  const options = toOptions(format, "number");
  return options === null || Object.getOwnPropertyNames(options).length === 0
    ? value
    : new Intl.NumberFormat(lng, options).format(value);
};

export const formatCurrency = (
  value: number,
  format: string,
  lng: string | undefined,
  options:
    | (InterpolationOptions & {
        // Disabling this line as this is the type declared in i18next
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
      })
    | undefined
): string | number => {
  const formatOptions = toOptions(format, "currency");
  /**
   * I am unable to get the options to be undefined in a test but as this is a type
   * in i18next it can be undefined...
   */
  /* istanbul ignore next */
  if (options?.currencyCodeOverride)
    formatOptions.currency = options.currencyCodeOverride;

  return formatOptions === null ||
    Object.getOwnPropertyNames(formatOptions).length === 0
    ? value
    : new Intl.NumberFormat(lng, formatOptions).format(value);
};

function toOptions(format: string, specifier: string) {
  if (format.trim() === specifier) {
    return {};
  } else {
    try {
      return JSON.parse(toJsonString(format, specifier));
    } catch (error) {
      return null;
    }
  }
}

function toJsonString(format: string, specifier: string) {
  const inner = format
    .trim()
    .replace(specifier, "")
    .replace("(", "")
    .replace(")", "")
    .split(";")
    .map((param) =>
      param
        .split(":")
        .map((name) => `"${name.trim()}"`)
        .join(":")
    )
    .join(",");
  return "{" + inner + "}";
}
